module.exports = __webpack_public_path__ + "static/media/library.35886766.svg";